var _defs, _g, _text, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMomentumLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_201",
    "data-name": "Group 201",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 202.484,
    height: 32.238,
    viewBox: "0 0 202.484 32.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M8.608,26.957a12.627,12.627,0,0,0,6.867.337,12.526,12.526,0,0,0,6.671,2.565,11.347,11.347,0,0,1-13.538-2.9m5.9-2.334a12.58,12.58,0,0,0,3.016.617,11.362,11.362,0,0,1-1.743.66,11.433,11.433,0,0,1-1.273-1.277m2.522,2.208A12.571,12.571,0,0,0,20.1,25.184a12.653,12.653,0,0,0,8.511-4.9,11.318,11.318,0,0,1-4.389,8.294c-.358.034-.714.05-1.056.05a11.3,11.3,0,0,1-6.132-1.8M7.253,24.984a11.361,11.361,0,0,1-.842-8.779,12.724,12.724,0,0,0,5.807,7.38,12.658,12.658,0,0,0,2.037,2.642,11.315,11.315,0,0,1-7-1.243M25.283,14.976a12.582,12.582,0,0,0-.66-4.033,11.282,11.282,0,0,1,3.9,7.13A11.451,11.451,0,0,1,22,23.468a12.558,12.558,0,0,0,3.28-8.492M7.277,14.163A11.452,11.452,0,0,1,13.8,8.769,12.642,12.642,0,0,0,11.18,21.3a11.3,11.3,0,0,1-3.9-7.132M29.9,19.6a12.793,12.793,0,0,0-.065-1.284,12.638,12.638,0,0,0,.685-9.7,11.358,11.358,0,0,1-3.9,19.48A12.556,12.556,0,0,0,29.9,19.6M13.153,22.65a11.361,11.361,0,0,1-1.361-5.389,11.219,11.219,0,0,1,1.21-5.1,11.514,11.514,0,0,1,3.2-3.885c.358-.033.713-.05,1.055-.05a11.363,11.363,0,0,1,5.389,1.36,11.358,11.358,0,0,1,1.36,5.388,11.21,11.21,0,0,1-1.211,5.1,11.508,11.508,0,0,1-3.2,3.886c-.358.033-.713.05-1.055.05a11.362,11.362,0,0,1-5.388-1.361M18.277,7a11.354,11.354,0,0,1,1.744-.661A11.451,11.451,0,0,1,21.3,7.616,12.562,12.562,0,0,0,18.277,7m5.309,1.654A12.664,12.664,0,0,0,21.548,6.01a11.309,11.309,0,0,1,7,1.244,11.351,11.351,0,0,1,.842,8.778,12.721,12.721,0,0,0-5.806-7.379M1.273,14.976A11.392,11.392,0,0,1,9.18,4.149,12.554,12.554,0,0,0,5.9,12.641a12.781,12.781,0,0,0,.065,1.284,12.639,12.639,0,0,0-.685,9.7,11.294,11.294,0,0,1-4.007-8.653M11.586,3.657c.358-.034.713-.05,1.055-.05a11.3,11.3,0,0,1,6.132,1.8,12.542,12.542,0,0,0-3.067,1.647,12.649,12.649,0,0,0-8.509,4.9,11.317,11.317,0,0,1,4.39-8.3m2.071-1.28a11.347,11.347,0,0,1,13.537,2.9,12.642,12.642,0,0,0-6.867-.337,12.53,12.53,0,0,0-6.67-2.566M18.541,0a12.541,12.541,0,0,0-7.454,2.432A12.638,12.638,0,0,0,6.317,25.92a12.636,12.636,0,0,0,10.944,6.318A12.538,12.538,0,0,0,24.716,29.8,12.637,12.637,0,0,0,29.486,6.318,12.632,12.632,0,0,0,18.541,0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.128,
    y1: 0.835,
    x2: 0.142,
    y2: 0.835,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cf"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 202.485,
    height: 32.237,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 48.112,
    height: 48.112,
    transform: "translate(-16.119 16.119) rotate(-45)",
    fill: "url(#linear-gradient)"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "momentum",
    transform: "translate(41.919 21.751)",
    fill: "#369",
    fontSize: 18,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.024em"
  }, "momen"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.025em"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.024em"
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "m"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SOLAR",
    transform: "translate(148.384 21.647)",
    fill: "#3cf",
    fontSize: 14,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.024em"
  }, "SOL"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.025em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "R"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMomentumLogo2);
export default __webpack_public_path__ + "static/media/momentum-logo-2.c4390a984ff4dcea4e4937ffc5ccf9cd.svg";
export { ForwardRef as ReactComponent };